module.exports = __webpack_public_path__ + "Fcx7Wwv8OzT71A3E1XOAjvesZW2xOQ-xsNqO47m55DA.831124e4eef07d5999a8.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinnecta/EFactoringManager/src/assets/fonts/roboto/Fcx7Wwv8OzT71A3E1XOAjvesZW2xOQ-xsNqO47m55DA.woff2
// module id = ../../../../../src/assets/fonts/roboto/Fcx7Wwv8OzT71A3E1XOAjvesZW2xOQ-xsNqO47m55DA.woff2
// module chunks = styles